<div class="cov-top-bar d-print-none d-flex" covRevealFixedTopBar>
  @if (showBackLink$ | async; as showBackLink) {
    <cov-button [buttonType]="buttonType.STANDALONE_SECONDARY" (click)="back()">
      <cov-icon [iconName]="iconName.ARROW_LEFT"></cov-icon>
    </cov-button>
  }
  <div class="title-bar">
    @if (pageTitle$ | async; as pageTitle) {
      <h1>{{ pageTitle.key | transloco:pageTitle.params }}</h1>
    }
    @if ((!(asmAgent$ | async) || (impersonateActiveSession$ | async)) && !shouldHideSearchBar()) {
      <cov-search-bar id="cov-search" />
    }
  </div>
  <div class="d-flex gap-4 align-items-center menu-bar">
    <div class="cov-user" id="cov-user-preferences" [matMenuTriggerFor]="userPrefMenu">
      <cov-icon
        [iconName]="iconName.USER"
        id="cov-user-preferences"
        class="cov-user-icon cov-user-icon-authenticated"
      ></cov-icon>
      <!-- For Walk Me integration to identify user -->
      @if (walkMe) {
        <span class="d-none">{{ (currentUser$ | async)?.uid }}</span>
      }
    </div>

    <mat-menu #userPrefMenu="matMenu">
      <cov-user-preferences
        (click)="$event.stopPropagation()"
        [menu]="userPrefMenu"
      ></cov-user-preferences>
    </mat-menu>

    @if (walkMe) {
      @if (walkMe) {
        <div class="cov-walkme" id="cov-walkme" [matMenuTriggerFor]="walkmeMenu">
          <cov-icon class="cov-walkme-icon" [iconName]="iconName.COMPASS"></cov-icon>
        </div>
      }

      <mat-menu #walkmeMenu="matMenu" class="p-2">
        <cov-walkme-info (click)="$event.stopPropagation()"></cov-walkme-info>
      </mat-menu>
    }

    @if (!(asmAgent$ | async) || (impersonateActiveSession$ | async)) {
      <!-- Planend for future release -->
      <!-- <cov-placeholder id="cov-notification-bell" class="rounded">
      <cov-icon [iconName]="iconName.NOTIFICATIONS"></cov-icon>
    </cov-placeholder> -->

      @if (shownSoldTo()) {
        <cov-sold-to-information id="cov-sold-to-information" />
      } @else {
        <cov-sold-to-information
          id="cov-sold-to-information"
          [matMenuTriggerFor]="soldToMenu"
          (menuOpened)="isSoldToInformationOpen.set(true)"
          (menuClosed)="isSoldToInformationOpen.set(false)"
        />
        <mat-menu #soldToMenu="matMenu" [xPosition]="'before'">
          <cov-sold-to-information-menu
            [isOpen]="isSoldToInformationOpen()"
          ></cov-sold-to-information-menu>
        </mat-menu>
      }

      <cov-cart-display id="cov-cart"></cov-cart-display>
    }
  </div>
</div>
